import type { App } from 'vue'
import Antd from 'ant-design-vue'

import Container from '@/layout/Container.vue'

// 注册全局组件
export default function registerGlobComp(app: App) {
    app.use(Antd)
    app.component('Container', Container)
}
